import React from 'react';
import Abbr from '../../shared/Abbr';
import { HorseLink } from '../../shared/links/ProfileLink';
import StakeCell from '../../shared/cells/StakeCell';
import { sortByRaceName } from '../../utils/name';
import { zeroToDash } from '../../utils/number';

const columns = (type, isIreSelected) => {
    const stakeCell = {
        key: 'stake',
        header: `${isIreSelected ? '€' : '£'}1 Stake`,
        cell: StakeCell,
    };

    const commonColumns = [
        {
            key: 'groupName',
            header: ' ',
            sortFn: sortByRaceName('groupName'),
        },
        {
            key: 'wins',
            header: () => <Abbr title="wins" />,
        },
        {
            key: 'runs',
            header: () => <Abbr title={type === 'jockey' ? 'rides' : 'runs'} />,
        },
        {
            key: 'percent',
            header: '%',
        },
        {
            key: 'placed',
            header: () => <Abbr title="placed" />,
        },
    ];

    if (type === 'jockey') {
        return commonColumns.concat([
            {
                key: '2nd',
            },
            {
                key: '3rd',
            },
            {
                key: '4ths',
            },
            {
                key: 'winnings',
            },
            {
                key: 'totalEarnings',
            },
            {
                ...stakeCell,
            },
        ]);
    }

    return commonColumns.concat([
        {
            key: 'winsHorses',
            header: 'winners / horses',
        },
        {
            key: 'totalEarnings',
        },
        {
            ...stakeCell,
        },
        {
            key: 'horseUid',
            header: 'best in category',
            cell: HorseLink,
        },
        {
            key: 'rpr',
            cell: zeroToDash('rpr'),
        },
    ]);
};

export default columns;



// WEBPACK FOOTER //
// ./src/js/human/details/columns.jsx